export default __webpack_public_path__ + "static/equilibre_icon_book-a7f340fd6240de0b91a7a80d96289172.png";